import authService from "@/shared/services/api/auth-service";
import { IOtpVerify } from "@/shared/services/types/auth";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getUser = createAsyncThunk(
  "user/getUser",
  async (userData: IOtpVerify, thunkAPI) => {
    try {
      const response = await authService.otpVerify({
        email: userData.email,
        token: userData.token
      });
      if (response.success) {
        localStorage.setItem("accessToken", response.data.accessToken);
        localStorage.setItem("refreshToken", response.data.refreshToken);
        localStorage.setItem("user", JSON.stringify(response.data));
      }
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
